import React, { Component } from 'react'
import PropTypes from 'prop-types'
import '../App.css'
import './SearchTerm.css'
import PlainHeader from '../components/PlainHeader'
import DeleteModal from '../components/DeleteModal'
import Footer from '../components/Footer'
import SearchResultEdit from '../components/SearchResultEdit'

class SearchTerm extends Component {
  constructor() {
    super()
    this.handleSearchTermChange = this.handleSearchTermChange.bind(this)
    this.addSearchResult = this.addSearchResult.bind(this)
    this.renderResults = this.renderResults.bind(this)
    this.renderResult = this.renderResult.bind(this)
    this.getSearchIndex = this.getSearchIndex.bind(this)
  }
  handleSearchTermChange(e) {
    this.props.updateSearchTerm(e.target.value, this.props.match.params.searchid)
  }
  addSearchResult(event) {
    event.preventDefault()
    //if (this.searchTerm.value.trim()) {
      const result = {
        id: 'result-' + Date.now(),
        title: this.searchTitle.value.trim(),
        link: this.searchLink.value.trim(),
        descr: this.searchDescr.value.trim()
      }
      this.props.addSearchResult(this.props.match.params.searchid, result)
    //}
    this.addResultForm.reset()
  }
  getSearchTerm() {
    const i = this.getSearchIndex()
    if ( i > -1) {
      return this.props.searches[i].searchTerm
    } 
    return ""    
  }
  getSearchIndex() {
    const numSearches = this.props.searches.length
    if (numSearches > 0) {
      for (let i = 0; i < numSearches; i++) {
        if (this.props.match.params.searchid === this.props.searches[i].id) {
          return i;
        }
      }
      return -1
    }
    return -1
  }
  renderResults() {
    let searchIndex = this.getSearchIndex();
    let results = this.props.searches[searchIndex].results
    if (results !== undefined && results.length > 0) {
      return results.map(this.renderResult)
    } else {
      return (
        <p>You have no search results. Use the form above to add some.</p>
      )
    }
  }
  renderResult(result, resultIndex) {
    let searchIndex = this.getSearchIndex();
    return (
      <SearchResultEdit 
        key={result.id}
        result={result} 
        searchIndex={searchIndex} 
        resultIndex={resultIndex} 
        deleteSearchResult={this.props.deleteSearchResult} 
        updateSearchResult={this.props.updateSearchResult} 
        searches={this.props.searches}
        searchId={this.props.match.params.searchid}
        updateResultOrder={this.props.updateResultOrder} />
     
    )
  }
  render() {
    console.log('Route params? ', this.props.match.params.searchid)
    const searchTerm = this.getSearchTerm()
    if (this.props.loading) {
      console.log("Loading data.")
      return (
        <div>Loading...</div>
      )
    } else if (searchTerm === "") {
      console.log("Handling no data.")
      return (
        <div>Search term not found.</div>
      )
    } else {
      return (
        <div className="main">
          <PlainHeader />
          <div className="container settings">
            <h1 className="">
              Search Term: {searchTerm}
            </h1>
            <h2>Edit Search Term</h2>
            <p>To edit this search term, just type your changes in the box below. The term will update instantly.</p>
            <input className="input-edit-searchterm" type="text" name="searchResult" value={searchTerm} placeholder="Search Term"
                onChange={(e) => this.handleSearchTermChange(e)} />
            <h2>Add a New Search Result</h2>
            <div className="result-add">
              <form className="result-add-form" ref={(input) => this.addResultForm = input} onSubmit={(e) => this.addSearchResult(e)}>
                <div className="result-add-header">
                  <button className="btn">Add</button>
                </div>
                <div className="result-add-body">
                  <div className="result-add-input-group">
                    <label htmlFor="resultTitle">Title</label>
                    <input className="searchterm-input" required id="resultTitle" name="resultTitle" 
                            type="text" placeholder="Title" ref={(input) => this.searchTitle = input}/>
                  </div>
                  <div className="result-add-input-group">
                    <label htmlFor="resultLink">Link</label>
                    <input className="searchterm-input" required id="resultLink" name="resultLink" type="text" placeholder="http://www.example.com" ref={(input) => this.searchLink = input}/>
                  </div>
                  <div className="result-add-input-group">
                    <label htmlFor="resultDescr">Description</label>
                    <textarea rows="4" cols="36" maxLength="300" className="searchterm-input" required id="resultDescr" name="resultDescr" type="text" placeholder="Description" ref={(input) => this.searchDescr = input}/>
                  </div>
                  
                  
                </div>
              </form>
            </div>
            <h2>Edit or Delete Existing Search Results</h2>
            {this.renderResults()}
          </div>
          <DeleteModal 
            closeDeleteModal={this.props.closeDeleteModal} 
            confirmDeleteSearchItem={this.props.confirmDeleteSearchItem}
            hideDeleteModal={this.props.hideDeleteModal} />
          <Footer />
        </div>
      )
    }
    
  }
}

SearchTerm.contextTypes = {
  match: PropTypes.object,
  router: PropTypes.object
}

export default SearchTerm;


// WEBPACK FOOTER //
// ./src/pages/SearchTerm.js